export default __webpack_public_path__ + "static/favicon-0bdc280043a3a3266061e62e9adfa7a8.png";